import { useCallback } from 'react';
import useFromAmount from './use-from-amount.js';
import usePrefilledAmountId from './use-prefilled-amount-id.js';
import useToAmount from './use-to-amount.js';
const useResetForm = () => {
    const [, _setFromAmount, resetFromAmount] = useFromAmount();
    const [, _setToAmount, resetToAmount] = useToAmount();
    const [, setPrefilledAmountId] = usePrefilledAmountId();
    return useCallback(() => {
        setPrefilledAmountId(null);
        resetFromAmount();
        resetToAmount();
    }, [setPrefilledAmountId, resetFromAmount, resetToAmount]);
};
export default useResetForm;
